export const extractMonitorPayload = monitor => {
  const dragItem = monitor.getItem();
  return {
    dragItem: dragItem.dragItem,
    initialClientOffset: monitor.getInitialClientOffset(),
    initialSourceClientOffset: monitor.getInitialSourceClientOffset(),
    clientOffset: monitor.getClientOffset(),
    differenceFromInitialOffset: monitor.getDifferenceFromInitialOffset(),
    sourceClientOffset: monitor.getSourceClientOffset(),
    start: dragItem.start,
    end: dragItem.end
  };
};